var hotelLocationPages = {
  'aberdeen-airport-hotels': 'Aberdeen Airport hotels',
  'belfast-airport-hotels': 'Belfast airport hotels',
  'belfast-city-airport-hotels': 'Belfast City airport hotels',
  'birmingham-airport-hotels': 'Birmingham airport hotels',
  'bristol-airport-hotels': 'Bristol airport hotels',
  'bournemouth-airport-hotels': 'Bournemouth airport hotels',
  'cardiff-airport-hotels': 'Cardiff airport hotels',
  'coventry-airport-hotels': 'Coventry airport hotels',
  'doncaster-airport-hotels': 'Doncaster airport hotels',
  'dublin-airport-hotels': 'Dublin airport hotels',
  'eastmidlands-airport-hotels': 'East Midlands airport hotels',
  'edinburgh-airport-hotels': 'Edinburgh airport hotels',
  'exeter-airport-hotels': 'Exeter airport hotels',
  'gatwick-airport-hotels': 'Gatwick airport hotels',
  'glasgow-airport-hotels': 'Glasgow airport hotels',
  'heathrow-airport-hotels': 'Heathrow airport hotels',
  'inverness-airport-hotels': 'Inverness airport hotels',
  'leeds-bradford-airport-hotels': 'Leeds Bradford airport hotels',
  'liverpool-airport-hotels': 'Liverpool airport hotels',
  'london-city-airport-hotels': 'London-City airport hotels',
  'luton-airport-hotels': 'Luton airport hotels',
  'manchester-airport-hotels': 'Manchester airport hotels',
  'newcastle-airport-hotels': 'Newcastle airport hotels',
  'norwich-airport-hotels': 'Norwich airport hotels',
  'prestwick-airport-hotels': 'Prestwick airport hotels',
  'southampton-airport-hotels': 'Southampton airport hotels',
  'southend-airport-hotels': 'Southend airport hotels',
  'stansted-airport-hotels': 'Stansted airport hotels',
  'teesside-airport-hotels': 'Teesside airport hotels'
}

module.exports = hotelLocationPages



// WEBPACK FOOTER //
// ./shared/config/hotelLocationPages.js